import { createWebHistory } from 'vue-router'

// 教育站点路由，用于学校站点
const eduRouter = {
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'eduHome',
      meta: {
        depth: 1,
        needHeader: true
      },
      component: () => import('@edu/views/AppHome/AppHome.vue')
    },
    {
      path: '/docs/:name?',
      name: 'docs',
      component: () => import('@/views/AppDocs/index.vue')
    },

    {
      path: '/create/cartoonFigurine',
      name: 'createCartoonFigurine',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@/views/AppEduPages/views/AppCreateCartoonFigurine/index.vue')
    },
    {
      path: '/generator/spaceship',
      name: 'generatorSpaceship',
      meta: {
        needHeader: false,
        needLogin: true
      },
      component: () => import('@edu/views/AppGeneratorSpaceship/index.vue')
    },
    {
      path: '/generator/dreamJob',
      name: 'AppGeneratorDreamJob',
      meta: {
        needHeader: false,
        keepAlive: true,
        needFooter: false,
        depth: 3
      },
      component: () => import('@edu/views/AppGeneratorDreamJob/index.vue')
    },
    {
      path: '/generator/imageTo3D',
      name: 'generatorImageTo3D',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@edu/views/AppGeneratorImageTo3D/index.vue')
    },
    {
      path: '/generator',
      name: 'generator',
      meta: {
        depth: 2,
        headerTransparent: true
      },
      component: () => import('@/views/AppEduPages/views/AppGenerator/GeneratorEntry/index.vue')
    },
    {
      path: '/generator/image',
      name: 'generatorImage',
      meta: {
        needHeader: false,
        needFooter: false,
        keepAlive: true,
        depth: 3
      },
      component: () => import('@/views/AppEduPages/views/AppGenerator/GeneratorImage/index.vue')
    },
    {
      path: '/generator/3d',
      name: 'generator3D',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@/views/AppEduPages/views/AppGenerator/Generator3D/index.vue')
    },
    {
      path: '/generator/inpainting',
      name: 'generatorInpainting',
      meta: {
        needHeader: false,
        needFooter: false,
        keepAlive: true,
        depth: 3
      },
      component: () =>
        import('@/views/AppEduPages/views/AppGenerator/GeneratorInpainting/index.vue')
    }
  ]
}

export default eduRouter
